import {  Grid, List, ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../../common/style/Theme";

const Menu = (props) => {
    const navigate = useNavigate();

    const [index, setIndex] = useState(0);

    const handleNavigation = (link) => {
        if(link === "/whym5") {
            navigate("/about")
            setTimeout(() => {
                const section = document.getElementById("why-m5");
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                }
            }, 100);
        } else {
            navigate(link);
            window.scroll({
                top: 0,
                behavior: 'smooth'
            })
        }
        props.setAnchor({
            x: 0,
            y: 0,
        });
        props.setNavBg();
        props.setNavTextColor();
    }


    return (
        <Grid container style={{
            minHeight: "45vh",
            overflow: "hidden",
        }}>
            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }} style={{
                borderRight: `1px solid ${theme.palette.background.default}`,
                background: theme.palette.background.paper,
            }}>
                <List>
                    {props.anchor?.menuItems?.map((item, i) => (
                        <ListItem key={i}
                            style={{
                                background: index === i ? theme.palette.primary.light : "transparent",
                                cursor: "pointer",
                            }}
                            onClick={() => setIndex(i)}>
                                <ListItemButton>
                                    <ListItemIcon style={{
                                        color: theme.palette.primary.main,
                                    }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <Typography variant="body1" 
                                    style={{
                                        color: theme.palette.primary.main,
                                        fontWeight: 600,
                                    }}>
                                        {item.name}
                                    </Typography>
                                </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <List style={{
                    columnCount: 2,
                    borderRight: `1px solid ${theme.palette.background.default}`,
                    height: "100%",
                }}>
                    {props.anchor.menuItems?.[index]?.menuOptions?.map((item, i) => (
                        <ListItem key={i}
                            style={{
                                cursor: "pointer",
                            }}
                            onClick={() => handleNavigation(item.link)}>
                                <ListItemButton>
                                    <ListItemIcon style={{
                                        color: theme.palette.text.primary,
                                    }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <Typography variant="body1" 
                                    style={{
                                        color: theme.palette.text.primary,
                                        fontWeight: 600,
                                    }}>
                                        {item.name}
                                    </Typography>
                                </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }} style={{
                padding: "20px 40px"
            }}>
                {props.anchor.menuItems?.[index]?.icon}
                <Typography variant="h6"
                    style={{ marginTop: "20px", color: theme.palette.text.primary }}>
                    {props.anchor.menuItems?.[index]?.title}
                </Typography>
                <Typography variant="body2"
                    style={{ marginTop: "20px" }}>
                    {props.anchor.menuItems?.[index]?.description}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default Menu;